import { initialize } from 'redux-form'
import { put, putResolve } from 'redux-saga/effects'
import objectQuery from 'loankeeper-common/containers/objectQuery'

import { loadProductDetails } from '../../../store/product'
import { rulesFetched, rulesFetchFailed } from '../actions'
import { neededValidationRules, neededDropdowns, minMaxRuls, FORM_NAME } from '../constants'

export default function* (fields, ProductID, ProductHash, meta) {
  const result = yield putResolve(loadProductDetails({ productId: ProductID, productHash: ProductHash }))

  if (loadProductDetails.rejected.match(result)) {
    yield put(rulesFetchFailed(result.payload))
    return
  }

  // get only those validation rules that we need
  const validation = objectQuery(result.payload.details, neededValidationRules)

  // get only dropdown values from validation rules
  const dropdownValues = objectQuery(result.payload.details, neededDropdowns)

  // Loop through validation rules & check if some of rule's min/max
  // validators are same numbers. If so we need to asing min's value to
  // relevant field in conditions form
  const nonDropdownFields = minMaxRuls.reduce((result, { min, max, nameInForm }) => {
    if (validation[min] === validation[max]) {
      result[nameInForm] = validation[min]
    }

    return result
  }, {})

  yield put(initialize(FORM_NAME, { ...fields, ...dropdownValues, ...nonDropdownFields }))

  yield put(rulesFetched(validation))

  meta.resolve()
}
